export const SET_USER = 'SET_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_DOCUMENT = 'SET_DOCUMENT';
export const APPEND_DOCUMENTS = 'APPEND_DOCUMENTS';
export const SET_DOCUMENT_TITLE = 'SET_DOCUMENT_TITLE';
export const SET_EXTRACTED_QA = 'SET_EXTRACTED_QA';
export const SET_SUBMITTING_DOC = 'SET_SUBMITTING_DOC';
export const LOGIN_USER = 'LOGIN_USER';
export const SET_PROCESSING_STATE = "SET_PROCESSING_STATE";
export const SET_GENERATE = "SET_GENERATE";
export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_DOCUMENTS_QA = "SET_DOCUMENTS_QA";
export const SET_DOCUMENTS_TAGS = "SET_DOCUMENTS_TAGS";
export const SET_PROGRESS = "SET_PROGRESS";
export const SET_SUMMARY = "SET_SUMMARY";
export const SET_PROCESSED_NOTES = "SET_PROCESSED_NOTES";
export const ADD_PROCESSED_NOTE = "ADD_PROCESSED_NOTE";
export const REMOVE_PROCESSED_NOTE = "REMOVE_PROCESSED_NOTE";
export const DELETE__NOTE_FILE = "DELETE__NOTE_FILE";
export const RESET_PROCESSED_NOTES = "RESET_PROCESSED_NOTES";
// La Home lo manda al mount: azzera come RESET_PROCESSED_NOTES, ma NON se ci
// sono file scelti in attesa di «Genera» (STU-362, caso Martina dell'11/09).
export const RESET_PROCESSED_NOTES_UNLESS_PENDING = "RESET_PROCESSED_NOTES_UNLESS_PENDING";

// URL extraction actions
export const EXTRACT_URL_START = "EXTRACT_URL_START";
export const EXTRACT_URL_SUCCESS = "EXTRACT_URL_SUCCESS";
export const EXTRACT_URL_FAILURE = "EXTRACT_URL_FAILURE";
export const SET_LIMIT_REACHED = "SET_LIMIT_REACHED";
export const SET_POPUP_VIEWD = "SET_POPUP_VIEWD";
export const UPGRAGE_CLICKED = "UPGRAGE_CLICKED";
export const LAST_POPUP_DATE = "LAST_POPUP_DATE";
export const POPUP_CLOSED = "POPUP_CLOSED";
export const SET_LIMIT_EXAMS_REACHED = "SET_LIMIT_EXAMS_REACHED";
export const SET_FLASHCARDS_QA = "SET_FLASHCARDS_QA";


export const SET_INTERROGATION_QA = "SET_INTERROGATION_QA";
export const RESET_INTERROGATION_QA = "RESET_INTERROGATION_QA";
export const SET_CURRENT_EXAM_ID = "SET_CURRENT_EXAM_ID";


export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SET_QUIZ_QA = "SET_QUIZ_QA";

// Onboarding actions
export const START_ONBOARDING = "START_ONBOARDING";
export const COMPLETE_ONBOARDING = "COMPLETE_ONBOARDING";
export const SKIP_ONBOARDING = "SKIP_ONBOARDING";
export const SET_ONBOARDING_STEP = "SET_ONBOARDING_STEP";
export const SET_ONBOARDING_CONTEXT = "SET_ONBOARDING_CONTEXT";
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const SET_FEEDBACK = 'SET_FEEDBACK';
export const RESET_FEEDBACK = 'RESET_FEEDBACK';


// Azioni per cartelle
export const CREATE_FOLDER = 'CREATE_FOLDER';
export const UPDATE_FOLDER = 'UPDATE_FOLDER';
export const DELETE_FOLDER = 'DELETE_FOLDER';
export const ADD_DOCUMENT_TO_FOLDER = 'ADD_DOCUMENT_TO_FOLDER';
export const REMOVE_DOCUMENT_FROM_FOLDER = 'REMOVE_DOCUMENT_FROM_FOLDER';
export const SELECT_DOCUMENT = 'SELECT_DOCUMENT';
export const SYNC_FOLDERS = 'SYNC_FOLDERS';
export const REFRESH_FOLDERS = 'REFRESH_FOLDERS';

// Aggiunta costanti per azioni attualmente definite come stringhe letterali
export const FREE_DOCUMENTS_FROM_FOLDER = 'FREE_DOCUMENTS_FROM_FOLDER';
export const DOCUMENT_ADDED_TO_FOLDER_SUCCESS = 'DOCUMENT_ADDED_TO_FOLDER_SUCCESS';

// Aggiungo il nuovo tipo di azione SET_DOCUMENT_CLASSIFICATION
export const SET_DOCUMENT_CLASSIFICATION = 'SET_DOCUMENT_CLASSIFICATION';

// Nuovi tipi per la generazione del materiale didattico
export const GENERATE_SUBJECT_DOCUMENT = 'GENERATE_SUBJECT_DOCUMENT';
export const GENERATE_SUBJECT_DOCUMENT_SUCCESS = 'GENERATE_SUBJECT_DOCUMENT_SUCCESS';
export const GENERATE_SUBJECT_DOCUMENT_FAILURE = 'GENERATE_SUBJECT_DOCUMENT_FAILURE';

// Tipi per i popup
export const SET_POPUP_VIEWED = 'SET_POPUP_VIEWED';
export const SET_IS_GENERATING = "SET_IS_GENERATING";
export const SET_IS_PROCESSING = "SET_IS_PROCESSING";
export const SET__IS__COMBINED = "SET__IS__COMBINED";
export const SET_LOADING_MESSAGE = "SET_LOADING_MESSAGE";
export const SET_EXTRACTION_METADATA = "SET_EXTRACTION_METADATA";
export const SET_DOCUMENT_TAGS = "SET_DOCUMENT_TAGS";
export const CLEAR_DOCUMENT_CLASSIFICATION = "CLEAR_DOCUMENT_CLASSIFICATION";
export const SET_HAS_PREVIEW = "SET_HAS_PREVIEW";
export const SET_CUSTOM_INSTRUCTIONS = "SET_CUSTOM_INSTRUCTIONS";
export const SET_AUTO_PODCAST = "SET_AUTO_PODCAST";
export const CLEAR_CUSTOM_INSTRUCTIONS = "CLEAR_CUSTOM_INSTRUCTIONS";
export const SET_SHOW_TUTORIAL = "SET_SHOW_TUTORIAL";

// Cache management action types
export const CLEAR_USER_CACHE = 'CLEAR_USER_CACHE';
export const CLEAR_EXAM_CACHE = 'CLEAR_EXAM_CACHE';
export const CLEAR_DOCUMENT_CACHE = 'CLEAR_DOCUMENT_CACHE';

// Costanti per gestione modalità di studio
export const SET_STUDY_MODE = 'SET_STUDY_MODE';
export const SET_EXAM_DATE = 'SET_EXAM_DATE';
export const SET_STUDY_DATE_WARNING = 'SET_STUDY_DATE_WARNING';
export const SET_SELECTED_MATERIA = 'SET_SELECTED_MATERIA';
export const SET_MATERIA_WARNING = 'SET_MATERIA_WARNING';

// Costante per riordinamento documenti recenti
export const REORDER_RECENT_DOCUMENT = 'REORDER_RECENT_DOCUMENT';

// Costanti per gestione upload documenti pendenti
export const INCREMENT_PENDING_UPLOADS = 'INCREMENT_PENDING_UPLOADS';
export const DECREMENT_PENDING_UPLOADS = 'DECREMENT_PENDING_UPLOADS';
export const RESET_PENDING_UPLOADS = 'RESET_PENDING_UPLOADS';
export const RELOAD_PENDING_UPLOADS = 'RELOAD_PENDING_UPLOADS';

// Costante per titolo cartella in upload multipli
export const SET_FOLDER_TITLE = 'SET_FOLDER_TITLE';

// Cartella ESISTENTE di destinazione per i documenti in caricamento
// (Home V2 Centro Fonti; la Home v1 non la imposta mai)
export const SET_TARGET_FOLDER = 'SET_TARGET_FOLDER';

// Maturita 2026 action types
export const SET_MATURANDO_PROFILE = 'SET_MATURANDO_PROFILE';
export const SET_READINESS_SCORE = 'SET_READINESS_SCORE';
export const SET_MATURITA_EXAM_SESSION = 'SET_MATURITA_EXAM_SESSION';
export const UPDATE_MATURITA_PHASE = 'UPDATE_MATURITA_PHASE';
export const RESET_MATURITA_EXAM = 'RESET_MATURITA_EXAM';

// Upload processing status (Firestore onSnapshot listener per progress bar)
export const SET_DOC_PROCESSING_STATUS = 'SET_DOC_PROCESSING_STATUS';
export const CLEAR_DOC_PROCESSING_STATUS = 'CLEAR_DOC_PROCESSING_STATUS';

// Avanzamento VERO dell'estrazione del testo (dagli eventi onProgress di
// processFile), letto dalla card di caricamento. Non e' un timer.
export const SET_EXTRACTION_PROGRESS = 'SET_EXTRACTION_PROGRESS';
export const CLEAR_EXTRACTION_PROGRESS = 'CLEAR_EXTRACTION_PROGRESS';
